import { Component } from '@angular/core';
import { ThemeService } from './layout/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private themeService: ThemeService) { }
  title = 'Busly';

  ngOnInit() {
    this.themeService.initTheme();
  }
}
